import styles from "./PPTPollsPage.module.css";
import {POLL_TYPE,} from "../../utils/constants";

import {getShortName, } from "../../utils/helpers";
import React, {useEffect, useState} from "react";
import {QRCodeCanvas} from "qrcode.react";
import {useParams} from "react-router-dom";
import {PollApiCalls} from "../../apis/PollApiCalls";
import Skeleton from "react-loading-skeleton";
import {useSynLMSConfiguration} from "../../hooks/useSynLMSConfiguration";
import ViewPresentAttendance from "../PresentationPage/ViewPresentAttendance";
import ViewPresentPoll from "../PresentationPage/ViewPresentPoll";
import {useConfig} from "../../hooks/useConfig";
import { useTranslation } from "react-i18next";



export default function SlideOverallTemplate({ }) {
    const { t } = useTranslation();
    const {getPublishedPollDataFromKey, } = PollApiCalls();
    const {getRedirectUrl, canHavePollCode} = useSynLMSConfiguration();
    let config = useConfig();

    let {pollKey, pollCode} = useParams();
    let shortName = getShortName();
    const HOST = shortName + '.' + config.host_url;
    const [dataReady, setDataReady] = useState(false);
    const [poll, setPoll] = useState({});
    const [pollData, setPollData] = useState({});

    useEffect(() => {
       getPublishedPollDataFromKey(pollKey, pollCode).then(res => {
            let {poll= {}} = res;
           setPoll(poll);
           setPollData(res);
        }).finally(() => {
           setDataReady(true);
       });

    }, []);

    if (!dataReady) {
        return (
            <div className={`${styles.canvas}`}>
                <Skeleton borderRadius={10} inline={true} width={"100%"} height={"100%"}/>
            </div>
        );
    }


    let redirectUrl = getRedirectUrl(poll);
    let isPollCodeVisible = canHavePollCode(poll);

    const renderLeftPortion = () => {
        return (
            <div
                className={`${styles.canvasLeftPart} ${styles.column}`}
                style={{height: "100%", alignItems: "center", position: "relative"}}
            >
                <div style={{flex: 1}}/>
                {!!redirectUrl &&
                    <>
                        <span
                            style={{fontSize: 18, fontWeight: "700", maxWidth: "100%", textAlign: "center"}}
                        >{poll.pollTitle}</span>
                        {isPollCodeVisible &&
                            <>
                                <span className={styles.canvasJoinText}>{t("poll.joinAt", {url: HOST})}</span>
                                <span className={styles.pollCodeBadge}>{t("poll.useCode", {code: pollCode})}</span>
                            </>
                        }


                        <div className={styles.QRCodeWrapper} style={{marginTop: 25}}>
                            <QRCodeCanvas
                                id={`QR${pollCode}`}
                                size={130}
                                renderAs="canvas"
                                value={redirectUrl}
                            />
                        </div>
                    </>
                }

                {!redirectUrl &&
                    <span style={{fontSize: 25, fontWeight: "700", maxWidth: "100%", textAlign: "center"}}>
                        {poll.pollTitle}
                    </span>
                }

                <div style={{flex: 1}}/>
            </div>
        );
    }


    return (
        <div>
            <div className={`${styles.canvas} ${styles.row}`} data-yuja-slide={`overall`} style={{paddingTop: 20}}>
                {/*left portion*/}
                {renderLeftPortion()}

                {/*right portion*/}
                <div className={styles.column} style={{flex: 1, minWidth: 0, height: "100%", padding: 20, gap: 15}}>
                    {poll.pollType === POLL_TYPE.ATTENDANCE &&
                        <ViewPresentAttendance
                            pollData={pollData}
                            localState={"START POLL"}
                            setLocalState={() => {}}
                            resetPollData={() => {}}
                            userSettings={{}}
                        />
                    }
                    {poll.pollType !== POLL_TYPE.ATTENDANCE &&
                        <ViewPresentPoll
                            pollData={pollData}
                            localState={"START POLL"}
                            setLocalState={() => {}}
                            resetPollData={() => {}}
                            responseCountData={[]}
                            reactionCountData={[]}
                            userSettings={{}}
                        />
                    }
                </div>

                <div
                    style={{
                        position: "absolute",
                        top: 0, left: 0,
                        width: "100%", height: 35,
                        // color: "#E9F1F3",
                        background: "#E9F1F3",
                        display: "flex", alignItems: "center",
                        fontSize: 14, lineHeight: 1.6, justifyContent: "center"
                    }}
                >
                    {t("poll.engageSlideTopBannerText")}
                </div>
            </div>
        </div>

    );
}